import { apiSlice } from "../../apiSlice";

/* -------------------- Mutation Slice -------------------- */
export const inventorySpareMutationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    /* -------------------- REJECT -------------------- */
    rejectRequest: builder.mutation({
      query: ({ request_id, remarks }) => ({
        url: "/inventory/spares",
        method: "PATCH",
        params: { request_id, status: 2, remarks },
      }),

      async onQueryStarted({ request_id, remarks }, { dispatch, queryFulfilled }) {
        // Optimistic update
        const patchResult = dispatch(
          apiSlice.util.updateQueryData(
            "getInventorySparesList",
            {}, // or pass your filters if any
            (draft) => {
              const item = draft.entities[request_id];
              if (item) {
                item.status = 2;
                item.remarks = remarks;
                item.approval_status = "rejected"; // 🔹 add approval_status update
              }
            }
          )
        );

        try {
          await queryFulfilled;
        } catch (err) {
          patchResult.undo();
          console.error("Reject request failed:", err);
        }
      },
    }),

    /* -------------------- APPROVE -------------------- */
    approveRequest: builder.mutation({
      query: ({ request_id }) => ({
        url: "/inventory/spares",
        method: "PATCH",
        params: { request_id, status: 1 },
      }),

      async onQueryStarted({ request_id }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          apiSlice.util.updateQueryData(
            "getInventorySparesList",
            {},
            (draft) => {
              const item = draft.entities[request_id];
              if (item) {
                item.status = 1;
                item.approval_status = "approved"; // 🔹 update approval_status
              }
            }
          )
        );

        try {
          await queryFulfilled;
        } catch (err) {
          patchResult.undo();
          console.error("Approve request failed:", err);
        }
      },
    }),

  }),
});

export const {
  useRejectRequestMutation,
  useApproveRequestMutation,
} = inventorySpareMutationApiSlice;
